import React, { useEffect, useState } from "react";
import Footer2 from "../Components/Footer2";
import Navbar2 from "../Components/Navbar2";
import img from "../Assets/hiring.png";
// import img2 from "../Assets/Classroom-rafiki 4.png";
import { useParams } from "react-router-dom";
import { getLms } from "../Common/apis";
import Loader from "../Loader/Loader";
import Aos from "aos";

function LMS2() {
  const [loading, setLoading] = useState(true);
  const [lmsData, setLmsData] = useState([]);

  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true // animate only once
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getLms();
        setLmsData(res?.data || []);
      } catch (error) {
        console.error("Failed to fetch LMS data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <Loader />;
  console.log(lmsData)

  return (
    <div className="new-home">
      <Navbar2 />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="md:px-[80px] px-[28px] md:pt-[74px] pt-[10px]">
            <div className="flex md:flex-row flex-col justify-between items-center">
              <img
                src="/assets/services/logo3.svg"
                data-aos="flip-up"
                alt="vector"
                className="md:mb-[60px] mb-[40px]"
              />
              <div className="lms-box" data-aos="flip-right">
                <h6 className="font-sans font-[500] md:text-[31px] text-[20px] md:leading-[42px] leading-[32px] text-[#6953A3] md:max-w-[303px] max-w-[218px] w-full mx-auto text-center md:pt-[34px] pt-[16px] md:pb-[5px] pb-[4px]">
                  Welcome to edForce Hands-On Labs
                </h6>
                <p className="font-sans font-[400] md:text-[16px] text-[11px] md:leading-[26px] leading-[22px] text-center text-[#6953A3] md:max-w-[350px] max-w-[253px] w-full mx-auto">
                  edForce a Leading Workforce Upskilling Accelerator has been
                  helping organizations of all stratus with seamless training
                  Modules.
                </p>
              </div>
            </div>

           
              {lmsData.length >= 0 && (
                <div className="md:flex hidden items-center justify-center gap-[32px] md:px-[67px] px-[20px] mt-[40px]">
                  {/* Left Side */}
                  <div className="flex flex-col items-end">
                    {lmsData.slice(0, 2).map((item, index) => (
                      <div
                        key={item._id}
                        data-aos={index === 0 ? "flip-left" : "flip-up"}
                        className={`flex flex-col items-center gap-[12px] ${
                          index === 1 ? "mr-[121px] mt-[-18px]" : ""
                        }`}
                      >
                        <img
                          src={item.icon || "/assets/services/logo4.svg"}
                          alt={item.title}
                          className="w-[80px] h-[80px] object-contain"
                        />
                        <p className="max-w-[143px] w-full text-center font-[500] font-sans text-[24px] leading-[30px] text-[#FFFFFF] tracking-[-0.32px]">
                          {item.title}
                        </p>
                      </div>
                    ))}
                  </div>

                  {/* Center Static Image */}
                  <img
                    src="/assets/services/vector5.svg"
                    data-aos="flip-down"
                    alt=""
                  />

                  {/* Right Side */}
                  <div className="flex flex-col items-start">
                    {lmsData.slice(2, 4).map((item, index) => (
                      <div
                        key={item._id}
                        data-aos={index === 0 ? "flip-up" : "flip-right"}
                        className={`flex flex-col items-center gap-[12px] ${
                          index === 1 ? "ml-[121px] mt-[-18px]" : ""
                        }`}
                      >
                        <img
                          src={item.icon || "/assets/services/logo4.svg"}
                          alt={item.title}
                          className="w-[80px] h-[80px] object-contain"
                        />
                        <p className="max-w-[143px] w-full text-center font-[500] font-sans text-[24px] leading-[30px] text-[#FFFFFF] tracking-[-0.32px]">
                          {item.title}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}


            {/* <div className="md:flex hidden items-center justify-center gap-[32px] md:px-[67px] px-[20px]">
              <div className="flex flex-col items-end">
                <div data-aos="flip-left" className="flex flex-col items-center gap-[12px]">
                  <img src="/assets/services/logo4.svg" alt="" />
                  <p className="max-w-[143px] w-full text-center font-[500] font-sans text-[24px] leading-[30px] text-[#FFFFFF] tracking-[-0.32px]">Playground Labs</p>
                </div>
                <div data-aos="flip-up" className="flex flex-col items-center gap-[12px] mr-[121px] mt-[-18px]">
                  <img src="/assets/services/logo4.svg" alt="" />
                  <p className="max-w-[143px] w-full text-center font-[500] font-sans text-[24px] leading-[30px] text-[#FFFFFF] tracking-[-0.32px]">Playground Labs</p>
                </div>
              </div>
              <img src="/assets/services/vector5.svg" data-aos="flip-down" alt="" />
              <div className="flex flex-col items-start">
                <div className="flex flex-col items-center gap-[12px]" data-aos="flip-up">
                  <img src="/assets/services/logo4.svg" alt="" />
                  <p className="max-w-[143px] w-full text-center font-[500] font-sans text-[24px] leading-[30px] text-[#FFFFFF] tracking-[-0.32px]">Playground Labs</p>
                </div>
                <div className="flex flex-col items-center gap-[12px] ml-[121px] mt-[-18px]" data-aos="flip-right">
                  <img src="/assets/services/logo4.svg" alt="" />
                  <p className="max-w-[143px] w-full text-center font-[500] font-sans text-[24px] leading-[30px] text-[#FFFFFF] tracking-[-0.32px]">Playground Labs</p>
                </div>
              </div>
            </div> */}
            <div className="grid md:hidden grid-cols-2 gap-y-[40px] py-[46px] gap-x-[62px] px-[4px]">
              <div
                data-aos="flip-up"
                className="flex flex-col items-center gap-[12px]"
              >
                <img src="/assets/services/logo4.svg" alt="" />
                <p className="max-w-[143px] w-full text-center font-[500] font-sans text-[24px] leading-[30px] text-[#FFFFFF] tracking-[-0.32px]">
                  Playground Labs
                </p>
              </div>
              <div
                data-aos="flip-up"
                className="flex flex-col items-center gap-[12px]"
              >
                <img src="/assets/services/logo4.svg" alt="" />
                <p className="max-w-[143px] w-full text-center font-[500] font-sans text-[24px] leading-[30px] text-[#FFFFFF] tracking-[-0.32px]">
                  Playground Labs
                </p>
              </div>
              <div
                data-aos="flip-up"
                className="flex flex-col items-center gap-[12px]"
              >
                <img src="/assets/services/logo4.svg" alt="" />
                <p className="max-w-[143px] w-full text-center font-[500] font-sans text-[24px] leading-[30px] text-[#FFFFFF] tracking-[-0.32px]">
                  Playground Labs
                </p>
              </div>
              <div
                data-aos="flip-up"
                className="flex flex-col items-center gap-[12px]"
              >
                <img src="/assets/services/logo4.svg" alt="" />
                <p className="max-w-[143px] w-full text-center font-[500] font-sans text-[24px] leading-[30px] text-[#FFFFFF] tracking-[-0.32px]">
                  Playground Labs
                </p>
              </div>
            </div>
            <img
              data-aos="flip-up"
              src="/assets/services/vector5.svg"
              className="md:hidden block"
              alt=""
            />
          </div>
        </>
      )}
      <Footer2 />
    </div>
  );
}

export default LMS2;
